class CookieConsent {
    static enable(service) {
        return localStorage.setItem('cookieconsent_' + service, '1');
    }
    static hasConsent(service) {
        return localStorage.getItem('cookieconsent_' + service) === '1';
    }

    /*
     * Executes the callback, after we got consent
     */
    static onHasConsent(service, callback) {
        if(CookieConsent.hasConsent(service)) {
            callback();
        } else {
            setTimeout(() => CookieConsent.onHasConsent(service, callback), 200);
        }
    }
}

window.CookieConsent = CookieConsent;
